﻿$.fn.dxCtrlGridHistoIaCognoss = function custom_dxCtrlGridHistoIaCognoss(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridhistoiacognoss dx-ctrl");
        this.createInstance(new cdxCtrlGridHistoIaCognoss(this, option));
    }
    return this;
}

window.cdxCtrlGridHistoIaCognoss = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }
    if (typeof option.context_grid == 'undefined') option.context_grid = "gridhistocognossia"

    var dxGrid = null
    function mConstruit() {
        container.empty();
        container.css("height", "100%")

        dxGrid = $("<div/>").appendTo(container).dxCtrlVirtualGrid({
            bddCtrl: option.bddCtrl,
            noDataText: "Aucun historique ia cognoss",
            typeData: "histo_cognoss_ia",
            context_grid: option.context_grid,
            itemsToolbar: mGetLstButtonToolBar(),
            onDisplayButtonLigne: mGetLstButtonLigne,
            lstTypeGrille: ["Détails"],
            fields: mGetLstField(),
            allowCarto: false,
            allowFilter: true,
            allowLucene: true,
            allowCheck: true,
            getItemTemplateHeight: function () { return 80 },
            getAlignItem: function () { return "right" },
            itemTemplateGrille: function (container, dataTemplate, type) {
                $("<div>" + dataTemplate.code_appli + " &bull; " + dataTemplate.nom_base + " &bull; " + dataTemplate.type_ia + " &bull; " + dataTemplate.adresse_email + "</div>").appendTo(container)
                $("<div style='font-weight:bold;font-size:120%;'/>").appendTo(container).text(dataTemplate.question)
                var reponse = JSON.parse(dataTemplate.reponse)
                $("<div style='font-style:italic;opacity:0.7;white-space:normal;'/>").appendTo(container).html(reponse.html)
                reponse.liens.forEach(function (link) {
                    $("<div><a href='" + link.url + "'>" + link.description + "</a></div>").appendTo(container).attr("title", link.description + "<br/>" + link.url)
                })
                var result = dataTemplate.prix
                let entier = Math.floor(result).toString();
                let decimal = ((result - Math.floor(result)) || 0).toFixed(9).split('.')[1];
                entier = entier.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
                decimal = decimal.replace(/(\d{3})(?=\d)/g, "$1 ");
                result = entier + '.' + decimal + '';
                $("<div style='opacity:0.2'/>").appendTo(container).html(dataTemplate.token_input + "u. &bull; " + dataTemplate.token_output + "u. &bull; " + result + "€")
            },
            itemTemplateGrillePlus: function (container, dataTemplate, type) {
                var $S = $("<span style=''><i class='fas fa-certificate dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + dataTemplate.dcr.toDateIlya(true) + "</span>").appendTo(container)
                $S.attr("title", "Créé le " + dataTemplate.dcr.toFrenchDateTime())
            },
            itemTemplateIco: function (container, dataTemplate) {
                $("<i class='fafa fafa-mia'></i>").appendTo(container)
            },
            onClickDataGrid: function (container, dataGrid, dataTemplate) {
            },
        }).dxCtrlVirtualGrid("instance")
    }

    function mGetLstField() {
        var lst = []
        lst.push({
            name: "dcr",
            dataField: "dcr",
            caption: "Date création",
            icon: "fas fa-clock",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "date",
            filterLinkGrp: "dcr_tri",
            filterProperty: {
                filterOperations: ["=", "<>", "<", ">", "<=", ">=", "between", "isblank", "isnotblank", "superieurouegaletoday", "inferieurouegaletoday"]
            },
            calculateGroupValue: function (rowData) {
                return rowData.dcr.toGrpDate().id
            },
            calculateSortValue: function (rowData) {
                return rowData.dcr
            },
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-clock-rotate-left dx-theme-accent-as-text-color' style='padding-right:3px;'></i>Création: " + options.data.key.getGroupDateLibelle() + " (" + tot + ")")
            },
        })
        lst.push({
            name: "dcr_tri",
            dataField: "dcr_tri",
            allowGrid: true,
            visible: false
        })
        var lst = lst.concat([{
            name: "code_appli",
            dataField: "code_appli",
            caption: "Code appli",
            icon: "fas fa-rocket",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-at dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + options.column.caption + ": " + options.displayValue + " (" + tot + ")")
            }
        }, {
            name: "nom_base",
            dataField: "nom_base",
            caption: "Nom base",
            icon: "fas fa-database",
            allowFilter: true,
            allowGrid: true,
            allowGrouping: true,
            allowSorting: true,
            dataType: "string",
            groupCellTemplate: function (columnElement, options) {
                var tot = 0
                options.totalItem.data.aggregates.forEach(function (nb) { tot += nb })
                columnElement.html("<i class='fas fa-at dx-theme-accent-as-text-color' style='padding-right:3px;'></i>" + options.column.caption + ": " + options.displayValue + " (" + tot + ")")
            }
        }])
        return lst
    }

    function mGetLstButtonToolBar() {
        var items = []

        items.push({
            location: 'before',
            template: function (itemData, itemIndex, itemElement) {
                $("<div/>").appendTo(itemElement).dxCtrlButton({
                    icon: "fafa fafa-mia",
                    icon2: "fas fa-certificate",
                    colorIcone2: theme.colorBtIcon2,
                    opacityIcone2: "0.9",
                    txtTooltip: "Nouvel QR",
                    onClick: function (e) {
                        var popup = $("<div/>").appendTo("body").dxCtrlPopupBase({
                            fullscreen: false,
                            height: "auto",
                            width: 700,
                            title: "Q/R IA",
                            contentTemplate: function (contentElement) {
                                var dxTagB = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTagBox({
                                    label: "Code appli générale",
                                    labelMode: 'floating',
                                    dataSource: parametre.lst_appli_maitre,
                                    value: [parametre.lst_appli_all.filter(function (o) { return o.code_appli == parametre.code_appli })[0].code_appli_general],
                                    displayExpr: "code_appli",
                                    valueExpr: "code_appli",
                                    onValueChanged: function (e) {
                                    }
                                }).dxTagBox("instance")
                                var dxTxtQ = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTextBox({
                                    label: "Question",
                                    labelMode: 'floating',
                                    value: "",
                                    onValueChanged: function (e) {
                                    }
                                }).dxTextBox("instance")
                                var dxTxR = $("<div style='margin:5px;'/>").appendTo(contentElement).dxTextArea({
                                    label: "Réponse",
                                    labelMode: 'floating',
                                    value: "",
                                    height: 150,
                                    onValueChanged: function (e) {
                                    }
                                }).dxTextArea("instance")
                                $("<div/>").appendTo(contentElement).dxCtrlButton({
                                    text: "ok",
                                    onClick: function (e) {
                                        var result = ""
                                        dxTagB.option("value").forEach(function (codeAppli) {
                                            result += ((result.length > 0) ? "," : "") + codeAppli
                                        })
                                        option.bddCtrl.mAjaxCall({
                                            command: "saveqria",
                                            "lst_code_appli": result,
                                            "question": dxTxtQ.option("value"),
                                            "reponse": dxTxR.option("value")
                                        }, function (data) { })
                                        popup.hide()
                                        dxGrid.mReloadData()
                                    }
                                })
                            }
                        }).dxCtrlPopupBase("instance")
                        popup.show()
                    }
                }).dxCtrlButton("instance")
            }
        })

        return items
    }

    function mGetLstButtonLigne(toolbar, dataGrid, dataTemplate) {
        var items = []

        items.push({
            location: 'before',
            widget: 'dxButton',
            showText: "inMenu",
            options: {
                icon: "fas fa-xmark",
                elementAttr: { class: "dx-button-grille-ligne" },
                focusStateEnabled: false,
                text: "Supprimer",
                hint: "Supprimer",
                onClick(e) {
                    e.event.stopPropagation();
                    option.bddCtrl.mAjaxCall({ command: "delqria", id: dataTemplate.id_key })
                    dxGrid.mRemoveRow(dataGrid)
                }
            },
        })

        toolbar.option("items", items)
    }

    this.element = function () { return container }

    mConstruit();
}